import React from 'react'
import type { Activity } from '@paintscout/api'
import { formatName } from '@paintscout/util/builder/util'
import Highlight from '@paintscout/ui/components/Highlight'
import { useUsers } from '../../providers/UsersProvider'
import { withLiveOwnerName } from '../../util/withLiveOwnerName'

export interface ActivityOwnerProps {
  name?: string
  activity: Activity
  /**
   * Defaults to ' by '
   */
  prefix?: string
}

/**
 * Renders "by firstName lastName" if there is an owner, otherwise renders nothing
 */
export default function ActivityOwner(props: { activity: Activity; prefix?: string }) {
  const { activity, prefix = ' by ' } = props
  const { usersById } = useUsers()

  const isAutomaticDealStageChange =
    activity.details.activityType === 'deal-stage-changed' && activity.details.isAutomated
  const snapshotOwner = isAutomaticDealStageChange ? activity.details.quoteOwner : activity.details.owner
  // The owner snapshot on the activity is frozen at write time, so a renamed seat keeps rendering
  // the previous person's name. Resolve the live name the same way ActivityAvatar does (#21800).
  const owner = withLiveOwnerName(snapshotOwner, usersById)
  const name = formatName(owner)

  if (!name) {
    return null
  }

  return (
    <>
      {prefix}
      <Highlight>{name}</Highlight>
    </>
  )
}
